/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModuleSecondary_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
    } | null> | null;
    readonly " $refType": "HpRespPromoModuleSecondary_componentModule";
};
export type HpRespPromoModuleSecondary_componentModule$data = HpRespPromoModuleSecondary_componentModule;
export type HpRespPromoModuleSecondary_componentModule$key = {
    readonly " $data"?: HpRespPromoModuleSecondary_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModuleSecondary_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModuleSecondary_componentModule",
  "type": "PromoModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "PromoItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespPromoModulePromoItem_promotion",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '478c3d26d2ede0db43bff91a977fb358';
export default node;
